import { render, staticRenderFns } from "./groin.vue?vue&type=template&id=1f1b38b6"
import script from "./groin.vue?vue&type=script&lang=js"
export * from "./groin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports